import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<void>>;

const removeSharedUserForForm = (id: string, userId: string): ReturnType => {
    return Request.delete(`/data/forms/${id}/users/${userId}`);
};

export default removeSharedUserForForm;
